import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { cardLoadService } from '../../services/card-load/index.tsx';
import { makeServiceContext } from '../../services/service-context/index.tsx';
import {
	CARD_REFRESH_REQUEST,
	type CardRefreshRequestAction,
	cardRefreshSuccess,
} from '../../state/actions/cards/refresh/index.tsx';
import { projectIdSelector } from '../../state/selectors/app/index.tsx';
import { getDetailViewData } from '../../state/selectors/cards/index.tsx';
import {
	getIssueParents,
	issueParentsSelector,
} from '../../state/selectors/issue-parent/index.tsx';
import type { ActionsObservable, MiddlewareAPI, State } from '../../state/types.tsx';

const getRefreshCardId = (action: CardRefreshRequestAction, state: State) => {
	const {
		payload: { cardId },
	} = action;

	if (cardId) {
		return cardId;
	}

	const detailViewData = getDetailViewData(state);

	if (detailViewData) {
		return detailViewData.cardId;
	}

	return null;
};

export const cardRefreshEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$.ofType(CARD_REFRESH_REQUEST).flatMap((action: CardRefreshRequestAction) => {
		const state = store.getState();
		const cardId = getRefreshCardId(action, state);
		const issueParents = getIssueParents(state);
		const projectId = projectIdSelector(state);
		const parents = issueParentsSelector(state);

		/** TODO: issueParents check part below to be removed WHEN
		 * Swag supports fetching epic level issues OR
		 * FE updates backlog optimistically (in redux store) instead of relying on refetching issues via GraphQL
		 */
		if (!cardId || issueParents[String(cardId)]) {
			return Observable.empty<never>();
		}

		const serviceContext = makeServiceContext(state);

		return cardLoadService(serviceContext, cardId, projectId, parents)
			.map((card) => cardRefreshSuccess(card))
			.catch((error) => {
				log.safeErrorWithoutCustomerData(
					'backlog.card-refresh-graphql.failure',
					'Failed to refresh issue',
					error,
				);

				return Observable.empty<never>();
			});
	});
